import { Theme } from "react-select";
import { useAATheme } from "./AAThemeContext";
import { ColorAA } from "./constants";
import Color from "color";

/**
 * Returns a react-select theme override that adapts to the current
 * Bootstrap dark/light theme (set via data-bs-theme on <html>).
 */
export const useReactSelectTheme = () => {
  const { isDarkMode } = useAATheme();

  return (baseTheme: Theme): Theme => {
    if (!isDarkMode) return baseTheme;

    return {
      ...baseTheme,
      colors: {
        ...baseTheme.colors,
        primary: ColorAA.violet,
        primary75: Color(ColorAA.violet).alpha(0.75).hexa(),
        primary50: Color(ColorAA.violet).alpha(0.5).hexa(),
        primary25: Color(ColorAA.violet).alpha(0.25).hexa(),
        danger: ColorAA.pink,
        dangerLight: Color(ColorAA.pink).alpha(0.25).hexa(),
        neutral0: ColorAA.lightBlack, // control bg, menu bg
        neutral5: Color(ColorAA.lightBlack).alpha(0.5).hexa(),
        neutral10: Color(ColorAA.beige).alpha(0.1).hexa(), // multi-value bg, borders
        neutral20: Color(ColorAA.beige).alpha(0.2).hexa(), // control border, separator
        neutral30: Color(ColorAA.beige).alpha(0.3).hexa(), // hover border
        neutral40: Color(ColorAA.beige).alpha(0.4).hexa(), // indicator
        neutral50: Color(ColorAA.beige).alpha(0.5).hexa(), // placeholder
        neutral60: Color(ColorAA.beige).alpha(0.6).hexa(), // indicator hover
        neutral70: Color(ColorAA.beige).alpha(0.7).hexa(),
        neutral80: ColorAA.beige, // text (light beige)
        neutral90: ColorAA.lightBeige,
      },
    };
  };
};
